import { Component, Input, OnInit } from "@angular/core";
import { version } from "../../../package.json";

@Component({
  selector: "af-header",
  templateUrl: "af-header.html",
})
export class AfHeaderComponent implements OnInit {
  @Input()
  public clientname: string;
  public versionNumber: string;
  public ngOnInit() {
    this.versionNumber = version;
  }
}



// WEBPACK FOOTER //
// ./src/components/af-header/af-header.ts